/* eslint-disable no-unused-vars */
export enum BorderVariant {
    LIGHT = 'LIGHT',
    DARK = 'DARK'
}
